import {
  Button,
  Fade,
  Grid,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { Form, Formik } from "formik";
import React from "react";
import {
  initialValue,
  validationSchema,
} from "../../validation/Edit_Personal_Profile_Validation";
import TextFieldWrapper, { Selectwrapper } from "../../components/TextField";
import { useStyles } from "../../styles/mainStyles";
import { edit_personal_profile } from "../../redux/Login/LoginActions";
import { PagesUrl } from "../../redux/General/generalActions";

const EditPersonalInfo = ({ setEdit, profile, clear }) => {
  const [showPass, setShowPass] = React.useState(false);
  let border = useStyles();

  let { pages } = PagesUrl();
  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(values, props) => {
        edit_personal_profile({
          old_password: values.old_password,
          password: values.password,
          confirm_password: values.confirm_password,
          default_page_link: values.default_page_link,
          role: values.role === "مدیر" ? "manager" : "employee",
        }).then((res) => {
          if (res) {
            props.resetForm();
            localStorage.profile = JSON.stringify({ ...profile, ...values });
            setEdit(false);
          }
        });
      }}
    >
      {(formik) => {
        if (profile.cellphone.startsWith("0")) {
          formik.values.cellphone = profile.cellphone;
        } else {
          formik.values.cellphone = `0${profile.cellphone}`;
        }
        formik.values.email = profile.email;
        formik.values.first_name = profile.first_name;
        formik.values.last_name = profile.last_name;
        formik.values.ssn = profile.ssn;
        formik.initialValues.role = profile.role;
        formik.initialValues.default_page_link = profile.default_page_link;

        return (
          <Fade in={true} timeout={500}>
            <Form style={{ width: "100%", height: "100%" }}>
              <Grid
                container
                xs={12}
                item
                spacing={2}
                style={{ margin: "auto", height: "100%" }}
                justifyContent="center"
              >
                <Grid item xs={12} style={{ height: 50 }}>
                  <Typography variant="body1">ویرایش پروفایل من</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  className={border.border}
                  style={{ margin: 8, height: "calc(100% - 50px)" }}
                >
                  <Grid
                    item
                    xs={4}
                    container
                    spacing={2}
                    style={{ margin: "auto" }}
                  >
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="cellphone"
                        label="شماره موبایل"
                        style={{ backgroundColor: "#F2F2F6" }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="email"
                        label="ایمیل"
                        style={{ backgroundColor: "#F2F2F6" }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="first_name"
                        label="نام"
                        style={{ backgroundColor: "#F2F2F6" }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="last_name"
                        label="نام خوانوادگی"
                        style={{ backgroundColor: "#F2F2F6" }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="ssn"
                        label="کد ملی"
                        style={{ backgroundColor: "#F2F2F6" }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="old_password"
                        label="رمز عبور قبلی"
                        type={!showPass ? "password" : "text"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() => setShowPass(!showPass)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="password"
                        label="رمز عبور"
                        type={!showPass ? "password" : "text"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() => setShowPass(!showPass)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="confirm_password"
                        label="تکرار رمز عبور"
                        type={!showPass ? "password" : "text"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() => setShowPass(!showPass)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Selectwrapper name="role" label="گروه کاربری" />
                    </Grid>
                    <Grid item xs={12}>
                      <Selectwrapper
                        name="default_page_link"
                        label="صفحه پیش فرض"
                        options={pages}
                      />
                    </Grid>
                    <Grid item container xs={12}>
                      <Grid item xs={6} style={{ paddingLeft: 8 }}>
                        <Button
                          type="submit"
                          fullWidth
                          color="primary"
                          variant="contained"
                          disabled={!formik.isValid}
                        >
                          ذخیره
                        </Button>
                      </Grid>
                      <Grid item xs={6} style={{ paddingRight: 8 }}>
                        <Button
                          onClick={() => setEdit(false)}
                          fullWidth
                          color="primary"
                          variant="outlined"
                        >
                          انصراف
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </Fade>
        );
      }}
    </Formik>
  );
};

export default EditPersonalInfo;
